module.exports = __webpack_public_path__ + "static/media/badge_level_1_3.7287ca5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_level_1_3.png
// module id = 513
// module chunks = 0